export default __webpack_public_path__ + "1b9dd842fc278275770ebceb6957512a.svg";